export default __webpack_public_path__ + "static/media/not-sent-icon.885dc3d1.svg";